import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem, styled, Typography } from '@mui/material';
import { MuiIcon, Tooltip } from "@cirrus/ui-kit-ts"

import { Link } from "../../atoms/Link"

const MainLink = styled(Link)({
  display: "flex",
  gap: "0.2rem",
  alignItems: "center",
  fontWeight: 600,
  textTransform: "none",
  padding: 0,
})

const menuItemStyle = {
  cursor: 'default',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&:active': {
    backgroundColor: 'transparent',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'transparent',
  },
  '&.Mui-selected': {
    backgroundColor: 'transparent',
  },
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: "1rem",
  padding: "4px 8px"
};

const menuItemTitleStyle = {
  maxWidth: "158px",
  wordWrap: "break-word",
  whiteSpace: 'normal',
}

const infoButtonStyle = {
  '&.Mui-disabled': {
    color: "inherit",
  },
};

const ButtonWrapper = styled("div")({
  "& a:focus": {
    outline: "none !important"
  }
})

interface IArgs {
  items: {
    id: string,
    title: string,
    link?: string | null,
  }[],
  text: string | false,
  infoTooltip: string,
  linkTooltip: string,
  maxMenuHeight?: number | "auto"
}

export const DropdownList = ({
  text,
  items,
  linkTooltip,
  infoTooltip,
  maxMenuHeight = "auto"
}: IArgs) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <MainLink
        onClick={handleClick}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {text}
        </Typography>
        <MuiIcon.ArrowDropDown sx={{fontSize: "2rem"}} />
      </MainLink>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: typeof maxMenuHeight === "string" ? maxMenuHeight : `${maxMenuHeight}px`
          }
        }}
      >
        {items.map((item) => {
          return (
            <MenuItem key={item.id} sx={menuItemStyle} disableRipple>
              <Box component="span" sx={menuItemTitleStyle}>
                <Typography variant="body2">{item.title}</Typography>
              </Box>
              <Box component="div">
                {item.link ? (
                  <Tooltip title={linkTooltip}>
                    <ButtonWrapper>
                      <IconButton component="a" href={item.link} onClick={handleClose}>
                        <MuiIcon.OpenInNew sx={{fontSize: "2rem", color: "#0055B0"}} />
                      </IconButton>
                    </ButtonWrapper>
                  </Tooltip>
                ) : (
                  <Tooltip title={infoTooltip}>
                    <IconButton sx={infoButtonStyle} disabled>
                      <MuiIcon.InfoOutlined sx={{fontSize: "2rem"}} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  );
};
